//-- Copyright (c) 2021 TMT Insights Group, LLC
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { setCurrentTable } from '@/redux/slices/dataTableSlice';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';

import DataTableFilters from '@/components/_common/Filters/DataTableFilters';
import DataTableLayout from '../_common/Layout/DataTableLayout';
import { useQuery } from '../_hooks/useQuery';
import ExceptionDrawer from './ExceptionDrawer';
import ExceptionsTitleBar from './ExceptionsTitleBar';
import useExceptionDrawer from '../_hooks/useExceptionDrawer';

const Exceptions = () => {
  const dispatch = useAppDispatch();
  const currentTableKey = useAppSelector(selectCurrentTableKey);
  const query = useQuery();
  const popoutOnly = query.get('popout');
  const { activeException, onDrawerClose, openExceptionInDrawer, exceptionLoading } = useExceptionDrawer();

  if (popoutOnly) {
    return <ExceptionDrawer exception={activeException} onDrawerClose={onDrawerClose} popoutOnly />;
  }

  useEffect(() => {
    dispatch(setCurrentTable('exceptions'));
  }, []);

  return (
    <>
      {currentTableKey === 'exceptions' && (
        <DataTableLayout
          tableKey="exceptions"
          activeRowId={activeException?.id}
          onRowClick={(_, item) => (activeException?.id !== item.id ? openExceptionInDrawer(item) : null)}
        >
          <ExceptionsTitleBar />
          <DataTableFilters />
          <ExceptionDrawer exception={activeException} onDrawerClose={onDrawerClose} loading={exceptionLoading} />
        </DataTableLayout>
      )}
    </>
  );
};

export default Exceptions;
